import { theme } from '@prose-ui';
import { Text } from '@prose-ui';
import { legacyTheme, styled } from '@prose-ui/legacy';

import { Image } from 'Components/Image';

import { deriskingModuleContent } from 'assets/content/landingPages/skincare';

const Container = styled.section`
  width: 100%;
  padding: 45px 0;

  background-color: ${theme.colors.neutral['200']};

  ${legacyTheme.breakpoints.up('md')} {
    padding: 60px 0;
  }
`;

const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding-left: 30px;
  gap: 40px;

  ${legacyTheme.breakpoints.up('sm')} {
    max-width: 624px;
    margin: 0 auto;
    padding: 0;
  }

  ${legacyTheme.breakpoints.up('md')} {
    flex-direction: row;
    justify-content: space-between;

    max-width: unset;
    margin: 0;
    padding: 0 64px;
  }

  ${legacyTheme.breakpoints.up('lg')} {
    gap: 100px;
    justify-content: center;
    max-width: unset;
  }
`;

const PropContainer = styled.div`
  display: flex;
  gap: 24px;
`;

export const DeriskingModule = () => (
  <Container data-testid="skincare-lp-derisking-module">
    <ContentContainer>
      {deriskingModuleContent.map((deriskingModule) => (
        <PropContainer key={deriskingModule.imageAlt}>
          <Image
            alt={deriskingModule.imageAlt}
            height={35}
            src={deriskingModule.image}
            width={38}
          />
          <Text as="p" color="primary.300" variant="bodyMd">
            {deriskingModule.description}
          </Text>
        </PropContainer>
      ))}
    </ContentContainer>
  </Container>
);
